import { API_BASE_URL, SERVICEURL } from "../constants/Constants";
import { APIs } from "../constants/Constants";
import axiosInterceptor from "../helpers/Interceptor";

export const getHopitalsList = async (body) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.FIRMLIST, {
      data: body,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getProjectsList = async (body) => {
  try {
    const response = await axiosInterceptor.post(APIs.PROJECTLIST, {
      data: body,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getProvidersList = async (body) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.PROVIDERLIST, {
      data: body,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const changeHospitalStatus = async (id) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.FIRMCHANGESTATUS, {
      data: {
        hospitalId: id,
      },
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getHospitalDetails = async (body) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.VIEWFIRM, {
      data: body,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getBucketDetails = async () => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.GET_BUCKET_DETAILS, {});
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getConfigurationDetails = async () => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.GET_CONFIGURATION_DETAILS, {});
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getFirmSettingDetails = async (clientId, type) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.EDITFIRMSETTINGS, {
      data: {
        clientId: clientId,
        type: type
      },
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const saveFirmSettingDetails = async (body) => {
  const payload = body?.data ?? body ?? {};
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.SAVEFIRMSETTINGS, {
      data: {
        qcSettingDto: payload.qcSettingDto,
        historyAvailableDto: payload.historyAvailableDto,
        unassignmentServiceDto: payload.unassignmentServiceDto,
        autoAssignEnableDto: payload.autoAssignEnableDto,
        disclaimerDto: payload.disclaimerDto,
        firmSettingsDto: payload.firmSettingsDto,
        reportTemplateDto: payload.reportTemplateDto,
        reportSettingDto: payload.reportSettingDto,
      },
    });
    return response;
  } catch (error) {
    if (error?.response?.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error?.response;
  }
};

export const changeUserStatus = async (id) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + "jwtServices/change-status/user",
      {
        data: {
          id: id,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const addHospital = async (
  action,
  firmDto,
  headerFile,
  footerFile,
  signatureFile2,
  signatureFile3,
  watermarkFile
) => {
  const firm = JSON.stringify(firmDto);
  console.log("firm in add/edit Hospital api ----",firm);
  var formData = new FormData();
  const blob = new Blob([firm], {
    type: "application/json",
  });

  formData.append("firmDto", blob);

  if (headerFile != null) {
    formData.append("headerFile", headerFile);
  }
  if (footerFile != null) {
    formData.append("footerFile", footerFile);
  }
  if (signatureFile2 != null) {
    formData.append("signatureFile2", signatureFile2);
  }
  if (signatureFile3 != null) {
    formData.append("signatureFile3", signatureFile3);
  }
    if (watermarkFile != null) {
    formData.append("watermarkFile", watermarkFile);
  }


  let URL = APIs.ADDHOSPITAL;
  if (action === "EDIT") {
    URL = APIs.EDITHOSPITAL;
  }
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + URL, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const addProject = async (
  action,
  firmDto,
  headerFile,
  footerFile,
  signatureFile2,
  signatureFile3,
  watermarkFile
) => {
  const firm = JSON.stringify(firmDto);
  console.log("firm in add/edit Hospital api ----",firm);
  var formData = new FormData();
  const blob = new Blob([firm], {
    type: "application/json",
  });

  formData.append("firmDto", blob);

  if (headerFile != null) {
    formData.append("headerFile", headerFile);
  }
  if (footerFile != null) {
    formData.append("footerFile", footerFile);
  }
  if (signatureFile2 != null) {
    formData.append("signatureFile2", signatureFile2);
  }
  if (signatureFile3 != null) {
    formData.append("signatureFile3", signatureFile3);
  }
   if (watermarkFile != null) {
    formData.append("watermarkFile", watermarkFile);
  }


  let URL = APIs.ADDPROJECT;
  if (action === "EDIT") {
    URL = APIs.EDITPROJECT;
  }
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + URL, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

  export const editFirmSettings = async (dto, headerFile, footerFile, signatureFile2, signatureFile3, watermarkFile) => {
  const formData = new FormData();
  
  const jsonBlob = new Blob([JSON.stringify({ data: dto })], {
    type: "application/json",
  });
  formData.append("data", jsonBlob);
  
  if (headerFile) formData.append("headerFile", headerFile);
  if (footerFile) formData.append("footerFile", footerFile);
  if (signatureFile2) formData.append("signatureFile2", signatureFile2);
  if (signatureFile3) formData.append("signatureFile3", signatureFile3);
  if (watermarkFile) formData.append("watermarkFile", watermarkFile);
  
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/firm/save-edit-firm-settings",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

   export const editProjectSettings = async (dto) => {
    try {
      const response = await axiosInterceptor.post(
        API_BASE_URL + SERVICEURL + "/project/save-edit-firm-settings",
        {
          data: dto,
        }
      );
      return response;
    } catch (error) {
      if (error.response.status === 403)
        window.location.assign(APIs.REDIRECTLOGOUT);
      else return error.response;
    }
  };

export const getImage = async (imageName, apiName) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + apiName, {
      data: {
        imageName: imageName,
      },
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const changeFirmStatus = async (hospitalId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.CHANGEFIRMSTATUS,
      {
        data: {
          hospitalId,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const changeStatusClient = async (id, role, status) => {
  const body = {
    connectionId: id,
    role: role,
    status: status ? 1 : -1,
  };
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.ACITVATE_DEACTIVE, {
      data: body,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const editFirmHeaderTemplate = async (body) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.EDITHEADERTEMPLATE, {
      data: {
        editFirmHeaderTemplateDto: body,
      },
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const listFirmHeaderTemplate = async (firmId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.LISTFIRMHEADERTEMPLATE,
      {
        data: {
          firmId: parseInt(firmId),
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getClientWarningStatus = async (clientId) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.CLIENTWARNINGSTATUS, {
      data: {
        firmId: clientId,
      },
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getModalityList = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.FIRMMODALITYLIST
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getSubModalityListNumbers = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.SUBMODALITYLISTNUMBERS
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const echoPacsNode = async (pacsNode) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.ECHOPACSNODE, {
      data: {
        pacsConfigDto: pacsNode,
      },
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};
